import { render, staticRenderFns } from "./DossierInfoScripts.vue?vue&type=template&id=5e4759ba&"
import script from "./DossierInfoScripts.vue?vue&type=script&lang=ts&"
export * from "./DossierInfoScripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e4759ba')) {
      api.createRecord('5e4759ba', component.options)
    } else {
      api.reload('5e4759ba', component.options)
    }
    module.hot.accept("./DossierInfoScripts.vue?vue&type=template&id=5e4759ba&", function () {
      api.rerender('5e4759ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierInfoScripts.vue"
export default component.exports